export default class MonitoramentoIndicadorItem {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.monitoramentoIndicadorId = 0;
        this.projetoId = 0;
        this.indicadorId = 0;
        this.meiosVerificacao = '';
        this.periodoVerificacao = '';
        this.comentario = '';
        this.documento = '';
        this.status = 0;

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.monitoramentoIndicadorId = model.monitoramentoIndicadorId;
        this.projetoId = model.projetoId;
        this.indicador = model.indicador;
        this.meiosVerificacao = model.meiosVerificacao;
        this.periodoVerificacao = model.periodoVerificacao;
        this.comentario = model.comentario;
        this.documento = model.documento;
        this.status = model.status;
    }
}